import React, {ReactElement} from "react";

import Image, {ImageObject} from "../../image/Image";

import {css, generateKeyId} from "/src/utils/utils";

import * as styles from "./widget-fast-facts.module.scss";

export interface WidgetFastFactsStatProps {
  headline: string;
  copy: string;
}

interface WidgetFastFactsProps {
  logo?: ImageObject;
  eyebrow?: string;
  stats?: Array<WidgetFastFactsStatProps>;
}

const WidgetFastFactsStat = (props: WidgetFastFactsStatProps): ReactElement => {
  const {headline, copy} = props;

  return (
    <div className={styles.widgetFastFacts__statItem}>
      {headline && (
        <p className={css("p", styles.widgetFastFacts__statItem__headline)}>
          {headline}
        </p>
      )}

      {copy && (
        <p className={css("p", styles.widgetFastFacts__statItem__copy)}>
          {copy}
        </p>
      )}
    </div>
  );
};

const WidgetFastFacts = (props: WidgetFastFactsProps): ReactElement | null => {
  const {eyebrow, logo, stats} = props;

  if (!eyebrow && !logo && !stats) {
    return null;
  }

  return (
    <section className={css("widget-base", styles.widgetFastFacts)}>
      {logo && <Image image={logo} classes={styles.widgetFastFacts__logo} />}

      {eyebrow && (
        <p className={css("eyebrow", styles.widgetFastFacts__eyebrow)}>
          {eyebrow}
        </p>
      )}

      {stats &&
        stats.map((stat, i) => {
          if (!stat.headline && !stat.copy) {
            return null;
          }

          const key = generateKeyId(`widget-fast-facts-${stat.headline}-${i}`);

          return <WidgetFastFactsStat key={key} {...stat} />;
        })}
    </section>
  );
};

export default WidgetFastFacts;
